<div class="overlay" (click)="close()"></div>

<div class="modal" (click)="$event.stopPropagation()">
  <div class="header">
    <h2>Credit Terms &amp; Conditions</h2>
    <button class="close-btn" (click)="close()">✕</button>
  </div>

  <div class="content">
    <!-- reuse your existing TOS content component -->
    <app-tos-content-historical></app-tos-content-historical>
  </div>

  <div class="actions">
    <button class="btn" (click)="close()">Close</button>
  </div>
</div>